import { render, staticRenderFns } from "./SubAccount.vue?vue&type=template&id=259f52c3"
import script from "./SubAccount.vue?vue&type=script&lang=ts"
export * from "./SubAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports